export default __webpack_public_path__ + "static/media/step-three.abc58bd0.png";